import React from "react";

const AdminStatsCard = ({ item }) => {
    return (
        <div className="bg-white rounded-[14px] border border-[#e4e5e7] p-[18px] flex flex-col gap-[12px] hover:shadow-sm transition-all">

            {/* Top row */}
            <div className="flex items-center justify-between">

                {/* Icon */}
                <div
                    className="w-[36px] h-[36px] rounded-[10px] flex items-center justify-center"
                    style={{ background: item.bgColor }}
                >
                    <div style={{ color: item.color }}>
                        {item.icon}
                    </div>
                </div>

            </div>

            {/* Content */}
            <div>
                <p className="font-semibold text-[28px] text-[#212326] mb-[2px]">
                    {item.value}
                </p>
                <p className="text-[12px] text-[#717182] font-semibold">
                    {item.label}
                </p>
            </div>
        </div>
    );
};

export default AdminStatsCard;